var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_2465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5631 15.6042C15.6467 15.6042 18.1465 13.1045 18.1465 10.0209C18.1465 6.93732 15.6467 4.43758 12.5631 4.43758C9.47954 4.43758 6.9798 6.93732 6.9798 10.0209C6.9798 13.1045 9.47954 15.6042 12.5631 15.6042Z",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18817 29.5626V26.7709C4.18817 25.2901 4.77641 23.87 5.82349 22.8229C6.87057 21.7758 8.29071 21.1876 9.7715 21.1876H15.3548C16.8356 21.1876 18.2558 21.7758 19.3029 22.8229C20.3499 23.87 20.9382 25.2901 20.9382 26.7709V29.5626",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.334 4.61888C23.535 4.92638 24.5995 5.62486 25.3596 6.60419C26.1198 7.58352 26.5324 8.788 26.5324 10.0277C26.5324 11.2675 26.1198 12.472 25.3596 13.4513C24.5995 14.4306 23.535 15.1291 22.334 15.4366",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3132 29.5624V26.7708C29.3061 25.5385 28.8915 24.3431 28.1341 23.3711C27.3766 22.399 26.3189 21.7049 25.1257 21.3968",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_2465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5,
    height: 33.5,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.f36ca713649321978946806745a8b84c.svg";
export { ForwardRef as ReactComponent };